module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "loading"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    class: ['kfw-loading', _vm.hasTransition ? 'transition' : '']
  }, [_c('div', {
    staticClass: "loading-img"
  }), _vm._v(" "), _c('p', {
    staticClass: "kfw-text"
  }, [_vm._v("页面加载中，请稍候...")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eda94a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading/loading.vue
// module id = 12
// module chunks = 0